import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    checkChannel = new Subject();
    verificationChannel = new Subject();
    listTunkinChannel = new Subject();
    listHonorariumChannel = new Subject();
    listUangMakanChannel = new Subject();
    listPltPlhChannel = new Subject();
    exportPltPlhTxtChannel = new Subject();
    exportPltPlhChannel = new Subject();
    exportTunkinChannel = new Subject();
    exportTunkinTxtChannel = new Subject();
    exportHonorariumChannel = new Subject();
    exportHonorariumTxtChannel = new Subject();
    exportUangMakanChannel = new Subject();
    exportUangMakanTxtChannel = new Subject();
    syncChannel = new Subject();
    generateChannel = new Subject();
    setgenerateChannel = new Subject();
    exportMatchingChannel = new Subject();
    verificationMatchingChannel = new Subject();
    repository = new IndexRepository()
    checkStatusGenerateChannel = new Subject();
    openverificationChannel = new Subject();
    constructor() {
        this.checkChannel.next({status: apiResponse.INITIAL})
        this.verificationChannel.next({status: apiResponse.INITIAL})
        this.listTunkinChannel.next({status: apiResponse.INITIAL})
        this.listHonorariumChannel.next({status: apiResponse.INITIAL})
        this.listUangMakanChannel.next({status: apiResponse.INITIAL})
        this.listPltPlhChannel.next({status: apiResponse.INITIAL})
        this.exportTunkinChannel.next({status: apiResponse.INITIAL})
        this.exportTunkinTxtChannel.next({status: apiResponse.INITIAL})
        this.exportHonorariumChannel.next({status: apiResponse.INITIAL})
        this.exportHonorariumTxtChannel.next({status: apiResponse.INITIAL})
        this.exportUangMakanChannel.next({status: apiResponse.INITIAL})
        this.exportUangMakanTxtChannel.next({status: apiResponse.INITIAL})
        this.exportPltPlhChannel.next({status: apiResponse.INITIAL})
        this.exportPltPlhTxtChannel.next({status: apiResponse.INITIAL})
        this.syncChannel.next({status: apiResponse.INITIAL})
        this.generateChannel.next({status: apiResponse.INITIAL})
        this.checkStatusGenerateChannel.next({status: apiResponse.INITIAL})
        this.openverificationChannel.next({status: apiResponse.INITIAL})
        
        this.exportMatchingChannel.next({status: apiResponse.INITIAL})
        this.verificationMatchingChannel.next({status: apiResponse.INITIAL})
    }

    fetchCheck = async (query) => {
        try {
            this.checkChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheck(query).then((result) => {
                this.checkChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchVerification = async (query) => {
        try {
            this.verificationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchVerification(query).then((result) => {
                this.verificationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.verificationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    openVerification = async (query) => {
        try {
            this.openverificationChannel.next({status: apiResponse.LOADING})
            await this.repository.openVerification(query).then((result) => {
                this.openverificationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.openverificationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchRegenerate = async (query) => {
        try {
            this.generateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchGenerate(query).then((result) => {
                this.generateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.generateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    setGenerate = async (query) => {
        try {
            this.setgenerateChannel.next({status: apiResponse.LOADING})
            await this.repository.setGenerate(query).then((result) => {
                this.setgenerateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.setgenerateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchListTunkin = async (query) => {
        try {
            this.listTunkinChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListTunkin(query).then((result) => {
                this.listTunkinChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listTunkinChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchListHonorarium = async (query) => {
        try {
            this.listHonorariumChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListHonorarium(query).then((result) => {
                this.listHonorariumChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listHonorariumChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchListUangMakan = async (query) => {
        try {
            this.listUangMakanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListUangMakan(query).then((result) => {
                this.listUangMakanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listUangMakanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchListPltPlh = async (query) => {
        try {
            this.listPltPlhChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPltPlh(query).then((result) => {
                this.listPltPlhChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPltPlhChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportPltPlh = async (query) => {
        try {
            this.exportPltPlhChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportPltPlh(query).then((result) => {
                this.exportPltPlhChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportPltPlhChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportPltPlhTxt = async (query) => {
        try {
            this.exportPltPlhTxtChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportPltPlhTxt(query).then((result) => {
                this.exportPltPlhTxtChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportPltPlhTxtChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportTunkin = async (query) => {
        try {
            this.exportTunkinChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportTunkin(query).then((result) => {
                this.exportTunkinChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportTunkinChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportTunkinTxt = async (query) => {
        try {
            this.exportTunkinTxtChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportTunkinTxt(query).then((result) => {
                this.exportTunkinTxtChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportTunkinTxtChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportHonorarium = async (query) => {
        try {
            this.exportHonorariumChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportHonorarium(query).then((result) => {
                this.exportHonorariumChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportHonorariumChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportHonorariumTxt = async (query) => {
        try {
            this.exportHonorariumTxtChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportHonorariumTxt(query).then((result) => {
                this.exportHonorariumTxtChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportHonorariumTxtChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportUangMakan = async (query) => {
        try {
            this.exportUangMakanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportUangMakan(query).then((result) => {
                this.exportUangMakanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportUangMakanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportUangMakanTxt = async (query) => {
        try {
            this.exportUangMakanTxtChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportUangMakanTxt(query).then((result) => {
                this.exportUangMakanTxtChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportUangMakanTxtChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchSync = async (query) => {
        try {
            this.syncChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSync(query).then((result) => {
                this.syncChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.syncChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {   }
    }

    checkStatusGenerate = async (query) => {
        try {
            this.checkStatusGenerateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchcheckStatusGenerateChannel(query).then((result) => {
                this.checkStatusGenerateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkStatusGenerateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }


    fetchExportMatching = async (query) => {
        try {
            this.exportMatchingChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportMatching(query).then((result) => {
                this.exportMatchingChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportMatchingChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }



    fetchVerifikasiMatching = async (query) => {
        try {
            this.verificationMatchingChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchVerifikasiMatching(query).then((result) => {
                this.verificationMatchingChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportHonorariumChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
}

export default IndexBloc